export default ({ store }) => {
  store.dispatch('coachingFeedback/fetchCoachingFeedback')
}
